import { $authHost } from "..";

export default class SetNewPasswordEmployeeHttp {
  static setNewPasswordEmployee(data) {
    return $authHost.post(`/employee/createPassword`,data);
  }
  static setNewPasswordClient(data) {
    return $authHost.post(`/client/createPassword`,data);
  }
}